import React from "react";
import {createBrowserRouter, RouterProvider} from "react-router-dom";

import {NotFound} from "./screens/NotFound";
import {BackofficeRouter} from "./screens/BackofficeRouter";
import {OnboardingRegisterVisaMobile} from "./screens/VXLab/Simple/Mobile/OnboardingRegisterVisaMobile";
import {DisclosuresVisaMobile} from "./screens/VXLab/Simple/Mobile/DisclosuresVisaMobile";
import {CardDetailsVisaMobile} from "./screens/VXLab/Simple/Mobile/CardDetailsVisaMobile";
import {PhoneStep1VisaMobile} from "./screens/VXLab/Simple/Mobile/PhoneStep1VisaMobile";
import {PhoneStep2VisaMobile} from "./screens/VXLab/Simple/Mobile/PhoneStep2VisaMobile";
import {SkanId1VisaMobile} from "./screens/VXLab/Simple/Mobile/SkanId1VisaMobile";
import {SkanId2VisaMobile} from "./screens/VXLab/Simple/Mobile/SkanId2VisaMobile";
import {OnboardingSuccessVisaMobile} from "./screens/VXLab/Simple/Mobile/OnboardingSuccessVisaMobile";
import {OnboardingLandingVisaMobile} from "./screens/VXLab/Simple/Mobile/OnboardingLandingVisaMobile";
import {Corporativo} from "./screens/VXLab/Corporativo/Mobile/Corporativo";
import {CorporativoLanding} from "./screens/VXLab/Corporativo/Mobile/CorporativoLanding";
import {CorporativoCard} from "./screens/VXLab/Corporativo/Mobile/CorporativoCard";
import {CorporativoOnboardingTutorialEasy} from "./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingTutorialEasy";
import {CorporativoOnboardingWelcome} from "./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingWelcome";
import {CorporativoOnboardingStepper} from "./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingStepper";
import {CorporativoOnboardingCardId} from "./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingCardId";
import {CorporativoOnboardingPhone} from "./screens/VXLab/Corporativo/Mobile/CorporativoOnboardingPhone";
import {
  CorporativoBusinessBankingLoginWeb
} from "./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingLoginWeb";
import {
  CorporativoBusinessBankingProductSelectionCodeWeb
} from "./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingProductSelectionCodeWeb";
import {
  CorporativoBusinessBankingDocumentsWeb
} from "./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingDocumentsWeb";
import {
  CorporativoBusinessBankingMailWeb
} from "./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingMailWeb";
import {
  CorporativoBusinessBankingMailCodeWeb
} from "./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingMailCodeWeb";
import {
  CorporativoBusinessBankingSignupWeb
} from "./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingSignupWeb";
import {
  CorporativoBusinessBankingStepperWeb
} from "./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingStepperWeb";
import {
  CorporativoBusinessBankingCredentialsWeb
} from "./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingCredentialsWeb";
import {
  CorporativoBusinessBankingDocumentIdWeb
} from "./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingDocumentIdWeb";
import {
  CorporativoBusinessBankingCheckoutWeb
} from "./screens/BusinessBanking/Corporativo/Web/CorporativoBusinessBankingCheckoutWeb";
import {PixieOnboarding} from "./screens/VXLab/Pixie/Mobile/PixieOnboarding";
import {PixieLanding} from "./screens/VXLab/Pixie/Mobile/PixieLanding";
import {PixieCardDetails} from "./screens/VXLab/Pixie/Mobile/PixieCardDetails";
import {PixieOnboardingTutorialEasy} from "./screens/VXLab/Pixie/Mobile/PixieOnboardingTutorialEasy";
import {PixieOnboardingWelcome} from "./screens/VXLab/Pixie/Mobile/PixieOnboardingWelcome";
import {PixieOnboardingStepper} from "./screens/VXLab/Pixie/Mobile/PixieOnboardingStepper";
import {PixieOnboardingCardId} from "./screens/VXLab/Pixie/Mobile/PixieOnboardingCardId";
import {PixieOnboardingPhone} from "./screens/VXLab/Pixie/Mobile/PixieOnboardingPhone";
import {AdultosOnboarding} from "./screens/VXLab/Adults/Mobile/AdultosOnboarding";
import {AdultosLanding} from "./screens/VXLab/Adults/Mobile/AdultosLanding";
import {AdultosCardDetails} from "./screens/VXLab/Adults/Mobile/AdultosCardDetails";
import {AdultosOnboardingTutorialEasy} from "./screens/VXLab/Adults/Mobile/AdultosOnboardingTutorialEasy";
import {AdultosOnboardingWelcome} from "./screens/VXLab/Adults/Mobile/AdultosOnboardingWelcome";
import {AdultosOnboardingStepper} from "./screens/VXLab/Adults/Mobile/AdultosOnboardingStepper";
import {AdultosOnboardingCardId} from "./screens/VXLab/Adults/Mobile/AdultosOnboardingCardId";
import {AdultosOnboardingPhone} from "./screens/VXLab/Adults/Mobile/AdultosOnboardingPhone";
import {YoungOnboarding} from "./screens/VXLab/Young/Mobile/YoungOnboarding";
import {CorporativoTelco} from "./screens/Telco/Corporativo/Mobile/CorporativoTelco";
import {CorporativoLandingTelco} from "./screens/Telco/Corporativo/Mobile/CorporativoLandingTelco";
import {
  CorporativoOnboardingTutorialEasyTelco
} from "./screens/Telco/Corporativo/Mobile/CorporativoOnboardingTutorialEasyTelco";
import {CorporativoOnboardingWelcomeTelco} from "./screens/Telco/Corporativo/Mobile/CorporativoOnboardingWelcomeTelco";
import {CorporativoOnboardingStepperTelco} from "./screens/Telco/Corporativo/Mobile/CorporativoOnboardingStepperTelco";
import {CorporativoOnboardingCardIdTelco} from "./screens/Telco/Corporativo/Mobile/CorporativoOnboardingCardIdTelco";
import {CorporativoOnboardingPhoneTelco} from "./screens/Telco/Corporativo/Mobile/CorporativoOnboardingPhoneTelco";
import {CorporativoRegional} from "./screens/RegionalRetail/Corporativo/Mobile/CorporativoRegional";
import {CorporativoLandingRegional} from "./screens/RegionalRetail/Corporativo/Mobile/CorporativoLandingRegional";
import {CorporativoCardRegional} from "./screens/RegionalRetail/Corporativo/Mobile/CorporativoCardRegional";
import {
  CorporativoOnboardingTutorialEasyRegional
} from "./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingTutorialEasyRegional";
import {
  CorporativoOnboardingWelcomeRegional
} from "./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingWelcomeRegional";
import {
  CorporativoOnboardingStepperRegional
} from "./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingStepperRegional";
import {
  CorporativoOnboardingCardIdRegional
} from "./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingCardIdRegional";
import {
  CorporativoOnboardingPhoneRegional
} from "./screens/RegionalRetail/Corporativo/Mobile/CorporativoOnboardingPhoneRegional";
import {CorporativoLoginDashboard} from "./screens/VXLab/Corporativo/Mobile/CorporativoLoginDashboard";
import {UserDashboard} from "./screens/UserDashboard";
import {UserDetailsDashboard} from "./screens/UserDetailsDashboard";
import {YoungLanding} from "./screens/VXLab/Young/Mobile/YoungLanding";
import {YoungCardDetails} from "./screens/VXLab/Young/Mobile/YoungCardDetails";
import {YoungOnboardingTutorialEasy} from "./screens/VXLab/Young/Mobile/YoungOnboardingTutorialEasy";
import {YoungOnboardingWelcome} from "./screens/VXLab/Young/Mobile/YoungOnboardingWelcome";
import {YoungOnboardingStepper} from "./screens/VXLab/Young/Mobile/YoungOnboardingStepper";
import {YoungOnboardingCardId} from "./screens/VXLab/Young/Mobile/YoungOnboardingCardId";
import {YoungOnboardingPhone} from "./screens/VXLab/Young/Mobile/YoungOnboardingPhone";
import { MiddleYoung } from "./screens/VXLab/MiddleYoung/Mobile/MiddleYoung";
import { MiddleYoungLanding } from "./screens/VXLab/MiddleYoung/Mobile/MiddleYoungLanding";
import { MiddleYoungOnboardingTutorialEasy } from "./screens/VXLab/MiddleYoung/Mobile/MiddleYoungOnboardingTutorialEasy";
import { MiddleYoungOnboardingWelcome } from "./screens/VXLab/MiddleYoung/Mobile/MiddleYoungOnboardingWelcome";
import { MiddleYoungOnboardingStepper } from "./screens/VXLab/MiddleYoung/Mobile/MiddleYoungOnboardingStepper/MiddleYoungOnboardingStepper";
import { MiddleYoungOnboardingCardId } from "./screens/VXLab/MiddleYoung/Mobile/MiddleYoungOnboardingCardId";
import { MiddleYoungOnboardingPhone } from "./screens/VXLab/MiddleYoung/Mobile/MiddleYoungOnboardingPhone";
import { RegionalLogin } from "./screens/Regional/Corporativo/Mobile/RegionalLogin";
import { RegionalLanding } from "./screens/Regional/Corporativo/Mobile/RegionalLanding";
import { RegionalOnboardingWelcome } from "./screens/Regional/Corporativo/Mobile/RegionalOnboardingWelcome";
import { RegionalOnboardingStepper } from "./screens/Regional/Corporativo/Mobile/RegionalOnboardingStepper";
import { RegionalOnboardingCardId } from "./screens/Regional/Corporativo/Mobile/RegionalOnboardingCardId";
import { RegionalOnboardingPhone } from "./screens/Regional/Corporativo/Mobile/RegionalOnboardingPhone";
import { RegionalCardDetail } from "./screens/Regional/Corporativo/Mobile/RegionalCardDetail";
import { UniversityLogin } from "./screens/University/Corporativo/Mobile/UniversityLogin";
import { UniversityLanding } from "./screens/University/Corporativo/Mobile/UniversityLanding";
import { UniversityOnboardingWelcome } from "./screens/University/Corporativo/Mobile/UniversityOnboardingWelcome";
import { UniversityOnboardingStepper } from "./screens/University/Corporativo/Mobile/UniversityOnboardingStepper";
import { UniversityOnboardingCardId } from "./screens/University/Corporativo/Mobile/UniversityOnboardingCardId";
import { UniversityOnboardingPhone } from "./screens/University/Corporativo/Mobile/UniversityOnboardingPhone";
import { UniversityCardDetail } from "./screens/University/Corporativo/Mobile/UniversityCardDetail";
import { BackofficeBackground } from "./screens/Backoffice/Background";
import { XpressPlugLogin } from "./screens/XpressPlug/Mobile/XpressPlugLogin";
import { XpressPlugLanding } from "./screens/XpressPlug/Mobile/XpressPlugLanding";

const visaMobileBasePaths = ["vxlab", "wallet", "wallet_visa", "retail_banking"];

const visaMobileSuffixes = [
  { suffix: "onboarding_register-visa-mobile", element: <OnboardingRegisterVisaMobile /> },
  { suffix: "onboarding_register-wallet-mobile", element: <OnboardingRegisterVisaMobile /> },
  { suffix: "landing-visa-mobile", element: <OnboardingLandingVisaMobile /> },
  { suffix: "landing-wallet-mobile", element: <OnboardingLandingVisaMobile /> },
  { suffix: "card_details-visa-mobile", element: <CardDetailsVisaMobile /> },
  { suffix: "card_details-wallet-mobile", element: <CardDetailsVisaMobile /> },
  { suffix: "onboarding_disclosures-visa-mobile", element: <DisclosuresVisaMobile /> },
  { suffix: "onboarding_disclosures-wallet-mobile", element: <DisclosuresVisaMobile /> },
  { suffix: "onboarding_phone_step_01-visa-mobile", element: <PhoneStep1VisaMobile /> },
  { suffix: "onboarding_phone_step_01-wallet-mobile", element: <PhoneStep1VisaMobile /> },
  { suffix: "onboarding_phone_step_02-visa-mobile", element: <PhoneStep2VisaMobile /> },
  { suffix: "onboarding_phone_step_02-wallet-mobile", element: <PhoneStep2VisaMobile /> },
  { suffix: "onboarding_skan_id_01-visa-mobile", element: <SkanId1VisaMobile /> },
  { suffix: "onboarding_skan_id_01-wallet-mobile", element: <SkanId1VisaMobile /> },
  { suffix: "onboarding_skan_id_02-visa-mobile", element: <SkanId2VisaMobile /> },
  { suffix: "onboarding_skan_id_02-wallet-mobile", element: <SkanId2VisaMobile /> },
  { suffix: "onboarding_success-visa-mobile", element: <OnboardingSuccessVisaMobile /> },
  { suffix: "onboarding_success-wallet-mobile", element: <OnboardingSuccessVisaMobile /> },
];

const visaMobileRoutes = visaMobileBasePaths.flatMap((prefix) =>
    visaMobileSuffixes.map(({ suffix, element }) => ({ path: `/${prefix}-${suffix}`, element }))
);

const router = createBrowserRouter([
  // 🧩 CATCH-ALL: handles dynamic backoffice routes + NotFound
  { path: "/*", element: <BackofficeRouter /> },

  // =========================
  // CORPORATIVO
  // =========================
  /* BORRAR LUEGO DEL 01/10/2025
  { path: "/corporativo-landing", element: <CorporativoLanding /> },
  { path: "/corporativo-card-details", element: <CorporativoCard /> },
  { path: "/corporativo-onboarding", element: <Corporativo /> },
  { path: "/corporativo", element: <CorporativoScreen /> },
  { path: "/corporativo-onboarding-tutorial-easy", element: <CorporativoOnboardingTutorialEasy /> },
  { path: "/corporativo-onboarding-welcome", element: <CorporativoOnboardingWelcome /> },
  { path: "/corporativo-onboarding-steppper", element: <CorporativoOnboardingStepper /> },
  { path: "/corporativo-onboarding-card-id", element: <CorporativoOnboardingCardId /> },
  { path: "/corporativo-onboarding-phone", element: <CorporativoOnboardingPhone /> },
  { path: "/corporativo-login-dashboard", element: <CorporativoLoginDashboard /> },
  { path: "/corporativo-user-dashboard", element: <UserDashboard /> },
  { path: "/corporativo-user-details-dashboard", element: <UserDetailsDashboard /> },
*/

// NUEVAS rutas corporativo (vxlab)
  { path: "/vxlab-login-corporativo-mobile", element: <Corporativo /> },
  { path: "/vxlab-landing-corporativo-mobile", element: <CorporativoLanding /> },
  { path: "/vxlab-onboarding_register-corporativo-mobile", element: <Corporativo /> },
  { path: "/vxlab-card_details-corporativo-mobile", element: <CorporativoCard /> },
  { path: "/vxlab-onboarding_tutorial_easy-corporativo-mobile", element: <CorporativoOnboardingTutorialEasy /> },
  { path: "/vxlab-onboarding_welcome-corporativo-mobile", element: <CorporativoOnboardingWelcome /> },
  { path: "/vxlab-onboarding_steppper-corporativo-mobile", element: <CorporativoOnboardingStepper /> },
  { path: "/vxlab-onboarding_card_id-corporativo-mobile", element: <CorporativoOnboardingCardId /> },
  { path: "/vxlab-onboarding_phone-corporativo-mobile", element: <CorporativoOnboardingPhone /> },

// NUEVAS rutas MiddleYoung (sports)
  { path: "/sport-login-MIDDLEYOUNG-mobile", element: <MiddleYoung /> },
  { path: "/sport-landing-MIDDLEYOUNG-mobile", element: <MiddleYoungLanding /> },
  { path: "/sport-onboarding_register-MIDDLEYOUNG-mobile", element: <MiddleYoung /> },
  { path: "/sport-onboarding_tutorial_easy-MIDDLEYOUNG-mobile", element: <MiddleYoungOnboardingTutorialEasy /> },
  { path: "/sport-onboarding_welcome-MIDDLEYOUNG-mobile", element: <MiddleYoungOnboardingWelcome /> },
  { path: "/sport-onboarding_steppper-MIDDLEYOUNG-mobile", element: <MiddleYoungOnboardingStepper /> },
  { path: "/sport-onboarding_card_id-MIDDLEYOUNG-mobile", element: <MiddleYoungOnboardingCardId /> },
  { path: "/sport-onboarding_phone-MIDDLEYOUNG-mobile", element: <MiddleYoungOnboardingPhone/> },


  { path: "/sports-login-middleyoung-mobile", element: <MiddleYoung /> },
  { path: "/sports-landing-middleyoung-mobile", element: <MiddleYoungLanding /> },
  { path: "/sports-onboarding_register-middleyoung-mobile", element: <MiddleYoung /> },
  { path: "/sports-onboarding_tutorial_easy-middleyoung-mobile", element: <MiddleYoungOnboardingTutorialEasy /> },
  { path: "/sports-onboarding_welcome-middleyoung-mobile", element: <MiddleYoungOnboardingWelcome /> },
  { path: "/sports-onboarding_steppper-middleyoung-mobile", element: <MiddleYoungOnboardingStepper /> },
  { path: "/sports-onboarding_card_id-middleyoung-mobile", element: <MiddleYoungOnboardingCardId /> },
  { path: "/sports-onboarding_phone-middleyoung-mobile", element: <MiddleYoungOnboardingPhone /> },



  // CORPORATIVO WEB - BUSINESS BANKING
  { path: "/business_banking-login-corporativo-web", element: <CorporativoBusinessBankingLoginWeb /> },
  { path: "/business_banking-product_selection-corporativo-web", element: <CorporativoBusinessBankingProductSelectionCodeWeb /> },
  { path: "/business_banking-document-corporativo-web", element: <CorporativoBusinessBankingDocumentsWeb /> },
  { path: "/business_banking-mail-corporativo-web", element: <CorporativoBusinessBankingMailWeb /> },
  { path: "/business_banking-mail_code-corporativo-web", element: <CorporativoBusinessBankingMailCodeWeb /> },
  { path: "/business_banking-signup-corporativo-web", element: <CorporativoBusinessBankingSignupWeb /> },
  { path: "/business_banking-stepper-corporativo-web", element: <CorporativoBusinessBankingStepperWeb /> },
  { path: "/business_banking-credentials-corporativo-web", element: <CorporativoBusinessBankingCredentialsWeb /> },
  { path: "/business_banking-document_id-corporativo-web", element: <CorporativoBusinessBankingDocumentIdWeb /> },
  { path: "/business_banking-checkout-corporativo-web", element: <CorporativoBusinessBankingCheckoutWeb /> },

  // =========================
  // PIXIE
  // =========================
  /* BORRAR LUEGO DEL 01/10/2025
  { path: "/pixie-landing", element: <PixieLanding /> },
  { path: "/pixie-card-details", element: <PixieCardDetails /> },
  { path: "/pixie-onboarding", element: <PixieOnboarding /> },
  { path: "/pixie-onboarding-tutorial-easy", element: <PixieOnboardingTutorialEasy /> },
  { path: "/pixie-onboarding-welcome", element: <PixieOnboardingWelcome /> },
  { path: "/pixie-onboarding-steppper", element: <PixieOnboardingStepper /> },
  { path: "/pixie-onboarding-card-id", element: <PixieOnboardingCardId /> },
  { path: "/pixie-onboarding-phone", element: <PixieOnboardingPhone /> },
  { path: "/pixie-user-dashboard", element: <UserDashboard /> },
  { path: "/pixie-user-details-dashboard", element: <UserDetailsDashboard /> },
  { path: "/pixie-login-dashboard", element: <CorporativoLoginDashboard /> },
  */


  // NUEVAS rutas pixie (vxlab)
  { path: "/vxlab-login-pixie-mobile", element: <PixieOnboarding /> },
  { path: "/vxlab-landing-pixie-mobile", element: <PixieLanding /> },
  { path: "/vxlab-onboarding_register-pixie-mobile", element: <PixieOnboarding /> },
  { path: "/vxlab-card_details-pixie-mobile", element: <PixieCardDetails /> },
  { path: "/vxlab-onboarding_tutorial_easy-pixie-mobile", element: <PixieOnboardingTutorialEasy /> },
  { path: "/vxlab-onboarding_welcome-pixie-mobile", element: <PixieOnboardingWelcome /> },
  { path: "/vxlab-onboarding_steppper-pixie-mobile", element: <PixieOnboardingStepper /> },
  { path: "/vxlab-onboarding_card_id-pixie-mobile", element: <PixieOnboardingCardId /> },
  { path: "/vxlab-onboarding_phone-pixie-mobile", element: <PixieOnboardingPhone /> },

  // =========================
  // ADULTOS
  // =========================
  /* BORRAR LUEGO DEL 01/10/2025
  { path: "/adultos-landing", element: <AdultosLanding /> },
  { path: "/adultos-card-details", element: <AdultosCardDetails /> },
  { path: "/adultos-onboarding", element: <AdultosOnboarding /> },
  { path: "/adultos-onboarding-tutorial-easy", element: <AdultosOnboardingTutorialEasy /> },
  { path: "/adultos-onboarding-welcome", element: <AdultosOnboardingWelcome /> },
  { path: "/adultos-onboarding-steppper", element: <AdultosOnboardingStepper /> },
  { path: "/adultos-onboarding-card-id", element: <AdultosOnboardingCardId /> },
  { path: "/adultos-onboarding-phone", element: <AdultosOnboardingPhone /> },
  { path: "/adultos-user-dashboard", element: <UserDashboard /> },
  { path: "/adultos-user-details-dashboard", element: <UserDetailsDashboard /> },
  { path: "/adultos-login-dashboard", element: <CorporativoLoginDashboard /> },
   */

// NUEVAS rutas adultos (vxlab)
  { path: "/vxlab-login-adultos-mobile", element: <AdultosOnboarding /> },
  { path: "/vxlab-landing-adultos-mobile", element: <AdultosLanding /> },
  { path: "/vxlab-onboarding_register-adultos-mobile", element: <AdultosOnboarding /> },
  { path: "/vxlab-card_details-adultos-mobile", element: <AdultosCardDetails /> },
  { path: "/vxlab-onboarding_tutorial_easy-adultos-mobile", element: <AdultosOnboardingTutorialEasy /> },
  { path: "/vxlab-onboarding_welcome-adultos-mobile", element: <AdultosOnboardingWelcome /> },
  { path: "/vxlab-onboarding_steppper-adultos-mobile", element: <AdultosOnboardingStepper /> },
  { path: "/vxlab-onboarding_card_id-adultos-mobile", element: <AdultosOnboardingCardId /> },
  { path: "/vxlab-onboarding_phone-adultos-mobile", element: <AdultosOnboardingPhone /> },

// =========================
// YOUNG
// =========================
  /* BORRAR LUEGO DEL 01/10/2025
  { path: "/young-landing", element: <YoungLanding /> },
  { path: "/young-card-details", element: <YoungCardDetails /> },
  { path: "/young-onboarding", element: <YoungOnboarding /> },
  { path: "/young-onboarding-tutorial-easy", element: <YoungOnboardingTutorialEasy /> },
  { path: "/young-onboarding-welcome", element: <YoungOnboardingWelcome /> },
  { path: "/young-onboarding-steppper", element: <YoungOnboardingStepper /> },
  { path: "/young-onboarding-card-id", element: <YoungOnboardingCardId /> },
  { path: "/young-onboarding-phone", element: <YoungOnboardingPhone /> },
  { path: "/young-user-dashboard", element: <UserDashboard /> },
  { path: "/young-user-details-dashboard", element: <UserDetailsDashboard /> },
  { path: "/young-login-dashboard", element: <CorporativoLoginDashboard /> },
  */

  // NUEVAS rutas young (vxlab)
  { path: "/vxlab-login-young-mobile", element: <YoungOnboarding /> },
  { path: "/vxlab-landing-young-mobile", element: <YoungLanding /> },
  { path: "/vxlab-onboarding_register-young-mobile", element: <YoungOnboarding /> },
  { path: "/vxlab-card_details-young-mobile", element: <YoungCardDetails /> },
  { path: "/vxlab-onboarding_tutorial_easy-young-mobile", element: <YoungOnboardingTutorialEasy /> },
  { path: "/vxlab-onboarding_welcome-young-mobile", element: <YoungOnboardingWelcome /> },
  { path: "/vxlab-onboarding_steppper-young-mobile", element: <YoungOnboardingStepper /> },
  { path: "/vxlab-onboarding_card_id-young-mobile", element: <YoungOnboardingCardId /> },
  { path: "/vxlab-onboarding_phone-young-mobile", element: <YoungOnboardingPhone /> },

  // Rutas corporativo Telco
  { path: "/telco-login-corporativo-mobile", element: <CorporativoTelco /> },
  { path: "/telco-landing-corporativo-mobile", element: <CorporativoLandingTelco /> },
  { path: "/telco-onboarding_register-corporativo-mobile", element: <CorporativoTelco /> },
  { path: "/telco-onboarding_tutorial_easy-corporativo-mobile", element: <CorporativoOnboardingTutorialEasyTelco /> },
  { path: "/telco-onboarding_welcome-corporativo-mobile", element: <CorporativoOnboardingWelcomeTelco /> },
  { path: "/telco-onboarding_steppper-corporativo-mobile", element: <CorporativoOnboardingStepperTelco /> },
  { path: "/telco-onboarding_card_id-corporativo-mobile", element: <CorporativoOnboardingCardIdTelco /> },
  { path: "/telco-onboarding_phone-corporativo-mobile", element: <CorporativoOnboardingPhoneTelco /> },

  // Rutas corporativo Regional
  { path: "/regional_retail-login-corporativo-mobile", element: <CorporativoRegional /> },
  { path: "/regional_retail-landing-corporativo-mobile", element: <CorporativoLandingRegional /> },
  { path: "/regional_retail-card-details-corporativo-mobile", element: <CorporativoCardRegional /> },
  { path: "/regional_retail-onboarding_register-corporativo-mobile", element: <CorporativoRegional /> },
  { path: "/regional_retail-onboarding_tutorial_easy-corporativo-mobile", element: <CorporativoOnboardingTutorialEasyRegional /> },
  { path: "/regional_retail-onboarding_welcome-corporativo-mobile", element: <CorporativoOnboardingWelcomeRegional /> },
  { path: "/regional_retail-onboarding_steppper-corporativo-mobile", element: <CorporativoOnboardingStepperRegional /> },
  { path: "/regional_retail-onboarding_card_id-corporativo-mobile", element: <CorporativoOnboardingCardIdRegional /> },
  { path: "/regional_retail-onboarding_phone-corporativo-mobile", element: <CorporativoOnboardingPhoneRegional /> },

  // Rutas Regional (new regional block with color1/color2 support)
  { path: "/regional-login-corporativo-mobile", element: <RegionalLogin /> },
  { path: "/regional-landing-corporativo-mobile", element: <RegionalLanding /> },
  { path: "/regional-onboarding_welcome-corporativo-mobile", element: <RegionalOnboardingWelcome /> },
  { path: "/regional-onboarding_steppper-corporativo-mobile", element: <RegionalOnboardingStepper /> },
  { path: "/regional-onboarding_card_id-corporativo-mobile", element: <RegionalOnboardingCardId /> },
  { path: "/regional-onboarding_phone-corporativo-mobile", element: <RegionalOnboardingPhone /> },
  { path: "/regional-card_detail-corporativo-mobile", element: <RegionalCardDetail /> },

  // Rutas University
  { path: "/university-login-corporativo-mobile", element: <UniversityLogin /> },
  { path: "/university-landing-corporativo-mobile", element: <UniversityLanding /> },
  { path: "/university-onboarding_welcome-corporativo-mobile", element: <UniversityOnboardingWelcome /> },
  { path: "/university-onboarding_steppper-corporativo-mobile", element: <UniversityOnboardingStepper /> },
  { path: "/university-onboarding_card_id-corporativo-mobile", element: <UniversityOnboardingCardId /> },
  { path: "/university-onboarding_phone-corporativo-mobile", element: <UniversityOnboardingPhone /> },
  { path: "/university-card_detail-corporativo-mobile", element: <UniversityCardDetail /> },

  // =========================
  // VISA MOBILE
  // =========================
  ...visaMobileRoutes,

  // =========================
  // BACKOFFICE WEB
  // =========================
  // Dynamic backoffice routes handled by BackofficeRouter catch-all

  // =========================
  // XPRESSPLUG
  // =========================
  { path: "/xpressplug-login-corporativo-mobile", element: <XpressPlugLogin /> },
  { path: "/xpressplug-landing-corporativo-mobile", element: <XpressPlugLanding /> },
  { path: "/xpressplug-login-adultos-mobile", element: <XpressPlugLogin /> },
  { path: "/xpressplug-landing-adultos-mobile", element: <XpressPlugLanding /> },
  { path: "/xpressplug-login-pixie-mobile", element: <XpressPlugLogin /> },
  { path: "/xpressplug-landing-pixie-mobile", element: <XpressPlugLanding /> },
  { path: "/xpressplug-login-young-mobile", element: <XpressPlugLogin /> },
  { path: "/xpressplug-landing-young-mobile", element: <XpressPlugLanding /> },

  // Backoffice Background
  { path: "/backoffice-background", element: <BackofficeBackground /> },

]);

export const App = () => {
  return <RouterProvider router={router} />;
};
